// ============================================================================
// ITALIAN TRANSLATIONS - BIBLE VERSES
// ============================================================================
// Raccolta di versetti ispiratori con riferimenti Strong

export const bibleVerses = [
  {
    reference: "Filippesi 4:13",
    text: "Io posso ogni cosa in Cristo che mi fortifica",
    version: "Nuova Riveduta",
    theme: "forza",
    strongNumbers: {
      "posso": "G1411", // δύναμις (dynamis) = potenza, forza
      "fortifica": "G1743" // ἐνδυναμόω (endynamoo) = fortificare
    },
    context: "Paolo parla della sua capacità di affrontare ogni situazione grazie a Cristo"
  },
  {
    reference: "Salmo 23:1",
    text: "Il SIGNORE è il mio pastore: nulla mi mancherà",
    version: "Nuova Riveduta",
    theme: "protezione",
    strongNumbers: {
      "pastore": "H7462", // רָעָה (ra'ah) = pascolare, custodire
      "mancherà": "H2637" // חָסֵר (chaser) = mancare, aver bisogno
    },
    context: "Davide esprime la sua totale fiducia nella provvidenza divina"
  },
  {
    reference: "Giovanni 3:16",
    text: "Perché Dio ha tanto amato il mondo, che ha dato il suo unigenito Figlio",
    version: "Nuova Riveduta",
    theme: "amore",
    strongNumbers: {
      "amato": "G25", // ἀγαπάω (agapao) = amare incondizionatamente
      "dato": "G1325" // δίδωμι (didomi) = dare, offrire
    },
    context: "Il versetto più celebre sull'amore di Dio per l'umanità"
  },
  {
    reference: "Filippesi 4:7",
    text: "E la pace di Dio, che supera ogni intelligenza, custodirà i vostri cuori",
    version: "Nuova Riveduta",
    theme: "pace",
    strongNumbers: {
      "pace": "G1515", // εἰρήνη (eirene) = pace, armonia
      "custodirà": "G5432" // φρουρέω (phroureo) = custodire, proteggere
    },
    context: "Promessa di protezione divina attraverso la pace interiore"
  },
  {
    reference: "Salmo 119:105",
    text: "La tua parola è una lampada al mio piede e una luce sul mio sentiero",
    version: "Nuova Riveduta",
    theme: "guida",
    strongNumbers: {
      "lampada": "H5216", // נִיר (niyr) = lampada, luminaria
      "luce": "H216" // אוֹר (or) = luce, illuminazione
    },
    context: "La Parola di Dio come guida nella vita quotidiana"
  },
  {
    reference: "Proverbi 3:5-6",
    text: "Confida nel SIGNORE con tutto il cuore e non ti appoggiare sul tuo discernimento",
    version: "Nuova Riveduta",
    theme: "fiducia",
    strongNumbers: {
      "Confida": "H982", // בָּטַח (batach) = confidare
      "cuore": "H3820" // לֵב (leb) = cuore, mente, volontà
    },
    context: "Invito a confidare in Dio piuttosto che nelle proprie capacità"
  },
  {
    reference: "Matteo 5:14",
    text: "Voi siete la luce del mondo; una città posta sopra un monte non può rimanere nascosta",
    version: "Nuova Riveduta",
    theme: "testimonianza",
    strongNumbers: {
      "luce": "G5457", // φῶς (phos) = luce, illuminazione spirituale
      "mondo": "G2889" // κόσμος (kosmos) = mondo, universo
    },
    context: "Gesù incoraggia i suoi discepoli a essere testimoni nel mondo"
  }
];

export default bibleVerses;
